'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SavedAddress;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ChevronRight = require('@deliveroo/icon-set/react/ChevronRight');

var _ChevronRight2 = _interopRequireDefault(_ChevronRight);

var _Pin = require('@deliveroo/icon-set/react/Pin');

var _Pin2 = _interopRequireDefault(_Pin);

var _Span = require('../../Span');

var _Span2 = _interopRequireDefault(_Span);

var _Icon = require('../../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LoadingIndicator = require('../../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'savedAddress': 'ccl-13da855f80c7ca1a',
  'link': 'ccl-fcbfd5f58478ea34',
  'formattedAddress': 'ccl-09785169d4450ac0'
};

/**
 * A saved address for display within the Location Search component.
 */

function SavedAddress(_ref) {
  var formattedAddress = _ref.formattedAddress,
      onClick = _ref.onClick,
      isLoading = _ref.isLoading;

  return _react2.default.createElement(
    'li',
    { className: styles.savedAddress },
    _react2.default.createElement(
      'a',
      { href: '#find_food', className: styles.link, onClick: onClick },
      _react2.default.createElement(_Icon2.default, { component: _Pin2.default, color: 'grey' }),
      _react2.default.createElement(
        'span',
        { className: styles.formattedAddress },
        _react2.default.createElement(
          _Span2.default,
          { size: 'small', color: 'black' },
          formattedAddress
        )
      ),
      !isLoading && _react2.default.createElement(_Icon2.default, { component: _ChevronRight2.default, color: 'teal', size: 18, adjacentHorizontalSpacing: 'small' }),
      isLoading && _react2.default.createElement(_LoadingIndicator2.default, { adjacentHorizontalSpacing: 'small' })
    )
  );
}

SavedAddress.displayName = 'SavedAddress';
SavedAddress.propTypes = {
  /**
   * Formatted address string
   */
  formattedAddress: _propTypes2.default.string.isRequired,

  /**
   * Click event handler.
   */
  onClick: _propTypes2.default.func.isRequired,

  /**
   * Boolean indicating if the address is currently loading
   */
  isLoading: _propTypes2.default.bool
};

SavedAddress.defaultProps = {
  isLoading: false
};